import { api } from "@/lib/api";

function supported() {
  return Boolean(
    typeof window !== "undefined"
    && "Notification" in window
    && "serviceWorker" in navigator
    && "PushManager" in window,
  );
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((character) => character.charCodeAt(0)));
}

async function pushConfig() {
  if (!supported()) return { enabled: false, public_key: null };
  try {
    const { data } = await api.get("/push/config");
    return data || { enabled: false, public_key: null };
  } catch {
    return { enabled: false, public_key: null };
  }
}

async function serviceWorkerRegistration() {
  await navigator.serviceWorker.register("/callsect-push-sw.js", { scope: "/" });
  return navigator.serviceWorker.ready;
}

export async function desktopNotificationState() {
  if (!supported()) return "unsupported";
  const config = await pushConfig();
  if (!config.enabled || !config.public_key) return "unavailable";
  if (Notification.permission === "denied") return "denied";
  if (Notification.permission !== "granted") return "default";
  try {
    const registration = await serviceWorkerRegistration();
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return "default";
    await api.post("/push/subscriptions", subscription.toJSON());
    return "enabled";
  } catch {
    return "unavailable";
  }
}

export async function enableDesktopNotifications() {
  if (!supported()) return "unsupported";

  // Keep the browser permission request directly inside the user's click gesture.
  let permission = Notification.permission;
  if (permission === "default") {
    permission = await Notification.requestPermission();
  }
  if (permission !== "granted") return permission === "denied" ? "denied" : "default";

  const config = await pushConfig();
  if (!config.enabled || !config.public_key) return "unavailable";

  const registration = await serviceWorkerRegistration();
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(config.public_key),
    });
  }
  await api.post("/push/subscriptions", subscription.toJSON());
  return "enabled";
}
